const questionItem = document.getElementsByClassName('faq-product-page__item');
let item;

for (item = 0; item < questionItem.length; item++) {
  questionItem[item].addEventListener('click', function () {
    this.classList.toggle('faq-product-page__active-item');
    let panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  });
}